import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";
import { ServiceResponseData } from "../ServiceResponseData";
import { DeleteClientProfileReqData } from "./DeleteClientProfileReqData";

const ENDPOINT = "/usermanagement/profiles";

export class DeleteClientProfileCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "delete";
    data: DeleteClientProfileReqData;

    constructor(data: DeleteClientProfileReqData) {
        super();
        this.data = data;
    }

    public async execute(): Promise<ServiceResponseData> {
        var res = await this.executeCommand(this.data);
        return new ServiceResponseData(res);
    }
}
